module.exports = __webpack_public_path__ + "static/media/One_Day_Workshop_m_mr.5f1b4429.jpg";